export const DialerBtnStyles = {
  color: '#4a5568',
  borderRadius: '0px',
  border: 0,
  backgroundColor: "#F0F6FF",
  _hover: {
    backgroundColor: "#F0F6FF",
    opacity: 0.9
  },
  _active: {
    backgroundColor: "#F0F6FF",
    
  },
  width: "90%",
  height: '60px',
}
export const TextBtnLabelStyles = {
  fontSize: '30px',
  fontWeight: '600',
  color: '#4A5568',
  height: '16px',
  paddingTop: '0',
  marginTop: '0',
  fontFamily: "Roboto, Arial, Helvetica, sans-serif"
}
export const TextSubStyles = {
  fontSize: '12px',
  fontWeight: '500',
  color: '#A0AEC0',
  height: '16px',
  paddingTop: '0',
  fontFamily: "Roboto, Arial, Helvetica, sans-serif",
  marginTop: "23px !important"
}
